<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Planned production time (1 box)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeProduct.group_package_planned_time_for_production ?
                            formatPlannedTime(activeProduct.group_package_planned_time_for_production) : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Planned production time (1 unit)" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeProduct.group_package_planned_time_for_production && activeProduct.bags_in_box ?
                            formatPlannedTime(activeProduct.group_package_planned_time_for_production, activeProduct.bags_in_box) : "-"
                }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../../../store";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "production-info-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct"])
    },
    methods: {
        formatPlannedTime(timeInSeconds, bagsInBox = null) {
            if (!timeInSeconds) return "-";

            if (bagsInBox) {
                timeInSeconds = timeInSeconds / bagsInBox
            } else if (bagsInBox === 0) {
                return "-";
            }

            const hours = Math.floor(timeInSeconds / 3600).toString().padStart(2, "0");
            const minutes = Math.floor((timeInSeconds % 3600) / 60).toString().padStart(2, "0");
            const seconds = Math.round(timeInSeconds % 60).toString().padStart(2, "0");
            return `${ hours.toString().padStart(2, "0") }:${ minutes.toString().padStart(2, "0") }:${ seconds.toString().padStart(2, "0") }`;
        }

    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
